import { Dayjs } from "dayjs";
import {UploadFile} from "antd";

class Activitat {
    constructor(
        public id: number = 0,
        public key: number = 0,
        public value: number = 0,
        public nom: string = "",
        public label: string = "",
        public any: string | Dayjs = "",
        public alta: string | Dayjs = "",
        public estat: string = "",
        public dataDescompte: string | Dayjs = "",
        public descompteAnticipat: string = "",
        public descompteGermans: string = "",
        public descompteSetmana: string = "",
        public idPlantilla: number = 0,
        public tipus: string = "",
        public preuRebut: number = 0,
        public textEmailPreu: string = "",
        public documents: Document[] = [],
        public files: Files = new Files()
    ) {}
}

class Document {
    constructor(
        public nom: string = "",
        public descripcio: string = "",
        public descompte: string = "",
        public obligatori: boolean = false
    ) {}
}

class Files {
    constructor(
        public fileList: UploadFile[] = []
    ) {}
}


export  default Activitat;
export {Document, Files};